﻿<script lang="ts" setup>
    import { reactive, onMounted, watch } from 'vue';
    import { setupInitValues } from './Contact';
    import { type Contact } from './Contact.access';
    import Form from '@cwd/shared/Components/Form/Form.vue';
    import { FormProps } from '@cwd/shared/components/Form/Form';

    const props = defineProps<{
        contact: Contact;
        submitting: boolean;
    }>();

    const state = reactive<{
        form: FormProps;
    }>({
        form: {
            data: {
                Email: {
                    modelValue: undefined,
                    group: $Resources.ContactModalProfileContactInformationHeading,
                    required: true,
                    input: {
                        label: $Resources.ContactEmailLabel,
                        placeholder: $Resources.ContactEmailPlaceholder,
                        type: 'email',
                    },
                },
                SmsNumber: {
                    modelValue: undefined,
                    group: $Resources.ContactModalProfileContactInformationHeading,
                    isValid: null,
                    inputTel: {
                        label: $Resources.ContactSmsNumberLabel,
                        placeholder: $Resources.ContactSmsNumberPlaceholder,
                        type: 'tel',
                    },
                },
                FirstName: {
                    modelValue: undefined,
                    group: $Resources.ContactModalProfileContactInformationHeading,
                    input: {
                        label: $Resources.ContactFirstNameLabel,
                        placeholder: $Resources.ContactFirstNamePlaceholder,
                    },
                },
                LastName: {
                    modelValue: undefined,
                    group: $Resources.ContactModalProfileContactInformationHeading,
                    input: {
                        label: $Resources.ContactLastNameLabel,
                        placeholder: $Resources.ContactLastNamePlaceholder,
                    },
                },
                CompanyName: {
                    modelValue: undefined,
                    group: $Resources.ContactModalProfileContactInformationHeading,
                    input: {
                        label: $Resources.ContactModalCompanyName,
                        placeholder: $Resources.ContactModalCompanyNamePlaceholder,
                    },
                },
                JobTitle: {
                    modelValue: undefined,
                    group: $Resources.ContactModalProfileContactInformationHeading,
                    input: {
                        label: $Resources.ContactModalJobTitle,
                        placeholder: $Resources.ContactModalJobTitlePlaceholder,
                    },
                },
                Website: {
                    modelValue: undefined,
                    group: $Resources.ContactModalProfileContactInformationHeading,
                    input: {
                        label: $Resources.ContactModalWebsite,
                        placeholder: $Resources.ContactModalWebsitePlaceholder,
                    },
                },
                Industry: {
                    modelValue: undefined,
                    group: $Resources.ContactModalProfileContactInformationHeading,
                    input: {
                        label: $Resources.ContactModalIndustry,
                        placeholder: $Resources.ContactModalIndustryPlaceholder,
                    },
                },
                StreetAddress: {
                    modelValue: undefined,
                    group: $Resources.ContactModalProfileContactInformationHeading,
                    input: {
                        label: $Resources.ContactModalStreetAddress,
                        placeholder: $Resources.ContactModalStreetAddressPlaceholder,
                    },
                },
                PostalCode: {
                    modelValue: undefined,
                    group: $Resources.ContactModalProfileContactInformationHeading,
                    input: {
                        label: $Resources.ContactModalPostalCode,
                        placeholder: $Resources.ContactModalPostalCodePlaceholder,
                    },
                },
                City: {
                    modelValue: undefined,
                    group: $Resources.ContactModalProfileContactInformationHeading,
                    input: {
                        label: $Resources.ContactModalCity,
                        placeholder: $Resources.ContactModalCityPlaceholder,
                    },
                },
                Region: {
                    modelValue: undefined,
                    group: $Resources.ContactModalProfileContactInformationHeading,
                    input: {
                        label: $Resources.ContactModalRegion,
                        placeholder: $Resources.ContactModalRegionPlaceholder,
                    },
                },
                Country: {
                    modelValue: undefined,
                    group: $Resources.ContactModalProfileContactInformationHeading,
                    input: {
                        label: $Resources.ContactModalCountry,
                        placeholder: $Resources.ContactModalCountryPlaceholder,
                    },
                },
                State: {
                    modelValue: undefined,
                    group: $Resources.ContactModalProfileContactInformationHeading,
                    input: {
                        label: $Resources.ContactModalState,
                        placeholder: $Resources.ContactModalStatePlaceholder,
                    },
                },
                Birthday: {
                    modelValue: undefined,
                    group: $Resources.ContactModalProfileContactInformationHeading,
                    input: {
                        label: $Resources.ContactModalBirthday,
                        placeholder: $Resources.ContactModalBirthdayPlaceholder,
                        type: 'date',
                    },
                },
                Gender: {
                    modelValue: undefined,
                    group: $Resources.ContactModalProfileContactInformationHeading,
                    input: {
                        label: $Resources.ContactModalGender,
                        placeholder: $Resources.ContactModalGenderPlaceholder,
                    },
                },
                Salutation: {
                    modelValue: undefined,
                    group: $Resources.ContactModalProfileContactInformationHeading,
                    input: {
                        label: $Resources.ContactModalSalutation,
                        placeholder: $Resources.ContactModalSalutationPlaceholder,
                    },
                } /*
                LastNpsDate: {
                    modelValue: undefined,
                    group: 'NPS & CSAT',
                    input: {
                        label: $Resources.ContactModalLastNpsDate,
                        type: 'date',
                        readonly: true,
                    },
                },
                LastNpsRating: {
                    modelValue: undefined,
                    group: 'NPS & CSAT',
                    input: {
                        label: $Resources.ContactModalLastNpsRating,
                        readonly: true,
                    },
                },
                LastCsatDate: {
                    modelValue: undefined,
                    group: 'NPS & CSAT',
                    input: {
                        label: $Resources.ContactLastCsatDate,
                        type: 'date',
                        readonly: true,
                    },
                },
                LastCsatRating: {
                    modelValue: undefined,
                    group: 'NPS & CSAT',
                    input: {
                        label: $Resources.ContactLastCsatRating,
                        readonly: true,
                    },
                },*/,
                SourceName: {
                    modelValue: undefined,
                    group: $Resources.GdprSourceHeading,
                    input: {
                        label: $Resources.GdprSourceLabel,
                    },
                },
                OptInDate: {
                    modelValue: undefined,
                    group: $Resources.GdprSourceHeading,
                    input: {
                        label: $Resources.GdprOptInDateLabel,
                        type: 'date',
                    },
                },
                PersonalReplyToEmail: {
                    modelValue: undefined,
                    group: $Resources.ContactModalPersonalReplyToHeading,
                    input: {
                        label: $Resources.PersonalReplyToEmailLabel,
                        type: 'email',
                    },
                },
                PersonalFromName: {
                    modelValue: undefined,
                    group: $Resources.ContactModalPersonalReplyToHeading,
                    input: {
                        label: $Resources.PersonalFromNameLabel,
                    },
                },
                ContactId: {
                    modelValue: undefined,
                    group: $Resources.ContactModalProfileAdvancedHeading,
                    input: {
                        label: $Resources.ContactIdLabel,
                        readonly: true,
                    },
                },
                ExternalId: {
                    modelValue: undefined,
                    group: $Resources.ContactModalProfileAdvancedHeading,
                    input: {
                        label: $Resources.ExternalIdLabel,
                        readonly: true,
                    },
                },
            },
        },
    });

    onMounted(async () => {
        setupInitValues(props.contact, state.form);

        watch(
            () => props.contact,
            async (newVal) => {
                if (!newVal) return;

                setupInitValues(newVal, state.form);
            }
        );
    });
</script>

<script lang="ts"></script>

<template>
    <Form
        class="fieldset-grid"
        :data="state.form.data"
        :submitting="props.submitting"
        :saveOnChange="true"
        @update:isValid="(key, newVal) => (state.form!.data[key].isValid = newVal)"
        @update:modelValue="(key, newVal) => !state.form.data[key].input?.readonly && (state.form.data[key].modelValue = newVal)"
        @onSubmitSingleInput="(key: string, newVal: any) => $emit('onSubmitSingleInput', key, newVal)"></Form>
</template>

<style></style>
